import { Button } from '@dixa/lib-shared-habla';
import { DecoratedFormProps, FormErrors } from 'redux-form';
import isEmail from 'validator/lib/isEmail';

import { AppDispatch } from 'bootstrap.store';
import { userModalApi } from 'components/usersModal';

import {
  ComposeEmailModalFormData,
  ComposeEmailModalProps,
} from './ComposeEmailModal';
import { ComposeEmailModalErrorType } from './ComposeEmailModalContainer';

/**
 * Synchronously validates the to, from and subject form data.
 *
 * @param formData The form data.
 */
export function validate(formData: ComposeEmailModalFormData) {
  const errors: FormErrors<
    ComposeEmailModalFormData,
    ComposeEmailModalErrorType
  > = {};
  if (!formData) {
    return errors;
  }

  const { toUser, fromEmails, subject } = formData;

  if (!toUser || (Array.isArray(toUser) && toUser.length === 0)) {
    errors.toUser = { _error: 'Required' };
  } else if (toUser?.[0]?.user?.email === undefined) {
    errors.toUser = { _error: 'To email is required' };
  }

  if (!fromEmails) {
    errors.fromEmails = { _error: 'Required' };
  } else if (fromEmails && !isEmail(fromEmails)) {
    errors.fromEmails = { _error: 'From email is not valid' };
  }

  if (!subject) {
    errors.subject = { _error: 'Required' };
  }

  return errors;
}

/**
 * Asynchronously validates that uniqueness of the email.
 *
 * @param formData The form data.
 * @param dispatch The redux dispatch function.
 * @param props The props.
 */
export async function asyncValidate(
  formData: ComposeEmailModalFormData,
  _dispatch: AppDispatch,
  props: DecoratedFormProps<
    ComposeEmailModalFormData,
    ComposeEmailModalProps,
    ComposeEmailModalErrorType
  >,
): Promise<void | {
  email: string | JSX.Element;
}> {
  const { change } = props;
  const { email, id } = formData?.toUser?.[0]?.user || {};

  if (!email || !isEmail(email) || id) return Promise.resolve();

  return userModalApi.validateEmail(email).then(({ data }) => {
    const { available, conflicting_id: userId } = data;
    if (!available && userId && change) {
      change('toUser[0].user.id', userId);
    }

    return Promise.resolve({
      email: userId ? (
        <span>
          Email is already used by another user{' '}
          <Button
            onClick={() => {
              props.userModalGetUser({ userId });
            }}
            variant="secondary"
          >
            Load user
          </Button>
        </span>
      ) : (
        'Email is already used by another user'
      ),
    });
  });
}
